import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';
import { FiLayers } from 'react-icons/fi';
import theme from 'styled-theming';
import { ReactComponent as Watson } from '../assets/watson.svg';
import { ReactComponent as GoogleDialogFlow } from '../assets/dialogflow.svg';
import { ReactComponent as LivePerson } from '../assets/liveperson.svg';
import { ReactComponent as Routing } from '../assets/icon-dynamic-routing.svg';

const iconColor = theme('mode', {
  light: (props) => props.theme.colors.black,
  dark: (props) => props.theme.colors.midLightGrey,
});

const KBLogo = styled(FiLayers)`
  color: ${iconColor};
  stroke-width: 1.5px;
`;

const WatsonLogo = styled(Watson)`color: ${iconColor};`;
const GoogleDialogFlowLogo = styled(GoogleDialogFlow)`color: ${iconColor};`;
const LivePersonLogo = styled(LivePerson)`color: ${iconColor};`;
const RoutingLogo = styled(Routing)`color: ${iconColor};`;

const ICON_SIZE = 18;

const getImageSrc = (type) => {
  switch (type) {
    case 'KnowledgeBase':
      return <KBLogo title={type} alt={type} width={ICON_SIZE} height={ICON_SIZE} />;
    case 'DialogFlow':
      return <GoogleDialogFlowLogo title={type} alt={type} width={ICON_SIZE} height={ICON_SIZE} />;
    case 'Watson':
      return <WatsonLogo title={type} alt={type} width={ICON_SIZE} height={ICON_SIZE} />;
    case 'Routing':
      return <RoutingLogo title={type} alt={type} width={ICON_SIZE} height={ICON_SIZE} />;
    default:
      return <LivePersonLogo title={type} alt={type} width={ICON_SIZE} height={ICON_SIZE} />;
  }
};

function TypeIcon(props) {
  const { type, ...otherProps } = props;

  return (
    <Box mr={3} {...otherProps}>
      {getImageSrc(type)}
    </Box>
  );
}

TypeIcon.defaultProps = {
  type: undefined,
};

TypeIcon.propTypes = {
  type: PropTypes.string,
};

export default TypeIcon;
